window.addEventListener('load', () => {
	let collectionWrapper = document.getElementById('collectionWrapper');
	if (collectionWrapper) {
		let collectionsAll = [...collectionWrapper.querySelectorAll('.collection')];
		collectionsAll.map((collectionA) => {
			collectionsAll.map((collectionB) => {
				if (
					collectionA.dataset.collectionhandle ===
					`m49-${collectionB.dataset.collectionhandle}`
				) {
					collectionB.append(collectionA);
					collectionB.classList.add('super-collection');
					collectionB.insertAdjacentHTML(
						'afterbegin',
						`<h2>${collectionB.dataset.collectionname} | ${
							collectionA.dataset.collectionname
						}</h2>`
					);
				}
			});
		});
	}
});
